import { useCallback } from 'react'
import { useMutation, useQueryClient } from 'react-query'

export interface AddToCartProps {
  userId: string
  productId: string
  quantity: number
  price: number
  userCustomizationData: string
}

export interface RemoveFromCartProps {
  userId: string
  productId: string
  cartId: string
}

export interface ProductProps {
  productId: string
  categoryId: string
  ocassionId: string
  productName: string
  imageIds: string
  productDescription: string
  colours: string
  marqueeNumber: string
  backdropText: string
  actualPrice: string
  discountedPrice: string
  rating: string
  included: string
  excluded: string
  dimension: string
  quantity: string
  rentedItems: string
  deliveryAndSetupDetails: string
  messageOnCake: string
  eggorEggless: string
  productDetails: string
  deliveryInformation: string
  careInstructions: string
  giftingText: string
  giftingImageId: string
  actDuration: string
  artistDetails: string
  whatToExpect: string
  additionalNotes: string
  propsQuantity: string
  propsSize: string
  propsText: string
  howToUse: string
  propDelivery: string
  noOfHours: string
  indoorOrOutdoor: string
  finalOutput: string
  skills: string
  outputDeliveryTime: string
  venue: string
  whereDoesItFitWell: string
  variant: string
  tag: string
  score: string
}

export interface CartItemsType {
  cartitems: [
    {
      id: 0
      userId: string
      productId: string
      quantity: 0
      product: ProductProps
      unitPrice: 0
      totalPrice: 0
    }
  ]
}

const addToCartFnc = async (cartItem: AddToCartProps) => {
  const res = await fetch('/api/cart/addToCart', {
    method: 'POST',
    body: JSON.stringify(cartItem)
  })

  if (!res.ok) {
    throw new Error('failed to add')
  }

  const response = await res.json()
  return response
}

export const updateCartfn = async (props: {
  userId: string
  productId: string
  quantity: number
  price: number
  userCustomizationData: string
  deliveryprice: number
  deliverydate: string
  timeslot: string
  discountedprice: string
  transportationcostperkm: string
  vendorids: string
  productname: string
  nearestVendor: string
  distance: string
  addressId: string
}) => {
  // console.log({ props })
  const res = await fetch('/api/cart/update', {
    method: 'POST',
    body: JSON.stringify(props)
  })

  if (!res.ok) {
    throw new Error('failed to update qty')
  }
  const response = await res.json()
  return response
}

export const removeFromCartFnc = async (cartItem: RemoveFromCartProps) => {
  const res = await fetch('/api/cart/removeFromCart', {
    method: 'POST',
    body: JSON.stringify(cartItem)
  })

  if (!res.ok) {
    throw new Error('failed to delete the item')
  }
  return res.json()
}

const useCartServices = () => {
  const queryClient = useQueryClient()

  const getCartItems = useCallback(async (user: string) => {
    try {
      const res = await fetch('/api/cart/addToCart', {
        method: 'POST',
        body: JSON.stringify({ userid: user })
      })
      if (!res.ok) {
        throw new Error('failed to fetch')
      }

      const response = await res.json()
      return response
    } catch (error) {
      throw new Error('failed to fetch')
    }
  }, [])

  const addToCart = useMutation(addToCartFnc, {
    onSuccess: () => {
      queryClient.invalidateQueries('cart')
    }
  })

  const removeFromCart = useMutation(removeFromCartFnc, {
    onSuccess: () => {
      queryClient.invalidateQueries('cart')
    }
  })

  const updateCart = (onSuccess?: () => void, onError?: (err: unknown) => void) =>
    useMutation(updateCartfn, { onSuccess, onError })

  return { getCartItems, addToCart, removeFromCart, updateCart }
}

export default useCartServices
